module.exports = __webpack_public_path__ + "assets/datatables.0ce5e7af.svg";